module.exports = require("@nestjs/axios");